<div class="adtabcontent">
  <app-column-header [headerData]="headerData" (topbtnaction)="menuBack()"></app-column-header>
  <!-- <div class="row">
    <div class="col-2-of-2">     
      <button type="button" class="btn btn-danger" *ngIf="menuParentId != 0" (click)="menuBack()">Back</button>
    </div>
  </div> -->
  <!-- <div class="adbcards"> -->
  <div class="" *ngFor="let data of menuWiseChildListdata">
    <div class="admsubtitle">
        {{data.parent_menu_name}}
    </div>

    <div class="admcontent rowlist">
      <ul class="admitemlist fourcolum">

        <li *ngFor="let data1 of data.child">
          <span>
            <svg>
              <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_menu_icon"></use>
            </svg>
          </span>
          <a href="" class="cursrponts">
            {{data1.gstibo_menu_name}}
            <p style="cursor: pointer;margin-right: 0; margin-left: 1px;" class="js-toggle-icon js-toggle-inner"
              *ngIf="data1.gstibo_with_child_inner_page == 1"
              (click)="viewChild(data1.gstibo_menu_id,data.parent_menu_id)">
              <b style="padding-left: 0; font-size: initial;cursor: pointer;">
                {{( (previousParentId != '0' && data.parent_menu_id == parentModuleId) ? '-' : '+')}} </b>
            </p>
          </a>
          <div [ngClass]="(data1.gstibo_menu_name =='Settings' ? 'actions disable-click':'actions')">
            <button class="edit" (click)="editMenu(data1.gstibo_menu_id)">
              <svg>
                <use [attr.xlink:href]="adminMenuIcon+'newedit'"></use>
              </svg>
            </button>
            <button class="delete" (click)="deleteMenu(data1.gstibo_menu_id)">
              <svg>
                <use [attr.xlink:href]="adminMenuIcon+'trash'"></use>
              </svg>
            </button>

          </div>
          <!-- <figure
          class="{{((data1.gstibo_menu_style =='grn-1' || data1.gstibo_menu_style =='') ? 'bgcolor_02' : data1.gstibo_menu_style)}}">
          <svg class="icon">
            <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_menu_icon"></use>
          </svg>
        </figure> -->

          <!-- <figcaption>
          {{data1.gstibo_menu_name}}
          <p style="cursor: pointer;margin-right: 0; margin-left: 1px;" class="js-toggle-icon js-toggle-inner"
            *ngIf="data1.gstibo_with_child_inner_page == 1"
            (click)="viewChild(data1.gstibo_menu_id,data.parent_menu_id)">
            <b style="padding-left: 0; font-size: initial;cursor: pointer;">
              {{( (previousParentId != '0' && data.parent_menu_id == parentModuleId) ? '-' : '+')}} </b>
          </p>
        </figcaption> -->
          <!-- <div class="editApp-pages">
          <a (click)="editMenu(data1.gstibo_menu_id)">Edit</a>
          <a (click)="deleteMenu(data1.gstibo_menu_id)">Delete</a>
        </div> -->

        </li>

      </ul>
    </div>
    <!-- sub -->

    <div class="cards-pages-sub" style="padding-left: 4rem;"
      *ngIf=" previousParentId != 0 && data.parent_menu_id == parentModuleId ">
      <div *ngFor="let dataSub of menuChildListdata">
        <figure
          class="{{((dataSub.gstibo_menu_style =='grn-1' || dataSub.gstibo_menu_style =='') ? 'bgcolor_02' : dataSub.gstibo_menu_style)}}">
          <svg class="icon">
            <use [attr.xlink:href]="srcPath.menuIconPath+dataSub.gstibo_menu_icon"></use>
          </svg>
        </figure>
        <figcaption>
          {{dataSub.gstibo_menu_name}}- x</figcaption>
        <div class="editApp-pages">
          <a (click)="editMenu(dataSub.gstibo_menu_id)">Edit</a>
          <a (click)="deleteMenu(dataSub.gstibo_menu_id)">Delete</a>

        </div>
      </div>

    </div>

    <!-- sub end -->

  </div>
  <!-- </div> -->



</div>

<!-- <div class="cards-pages">
      <div class="icon_group" *ngFor="let data1 of menuChildListdata">
            <figure (click)="viewChild(data1.gstibo_menu_id)" 
            class="{{((data1.gstibo_menu_style =='grn-1' || data1.gstibo_menu_style =='') ? 'bgcolor_02' : data1.gstibo_menu_style)}}">
                    <svg class="icon">
                      <use [attr.xlink:href]="srcPath.menuIconPath+data1.gstibo_menu_icon"></use>
                    </svg>
                  </figure>
                  <figcaption (click)="viewChild(data1.gstibo_menu_id)" >
                    {{data1.gstibo_menu_name}}</figcaption>
                  <div class="editApp-pages">
                    <a (click)="editMenu(data1.gstibo_menu_id)">Edit</a>
                    <a (click)="deleteMenu(data1.gstibo_menu_id)"
                      >Delete</a>
                     
                  </div>
                  <div class="editApp-pages-sub">
                      <a (click)="AddSubMenu(data1.gstibo_menu_id)">Add Sub Menu</a>
                  </div>
                  
          </div>
        </div> -->
<!-- 

<div class="iconBlock">

    <div class="appNames" *ngFor="let data of menuChildListdata">
      <h4 (click)="viewChild(data.gstibo_menu_id)"> {{data.gstibo_menu_name}}</h4>
      <p>
        <a
          (click)="editMenu(data.gstibo_menu_id)">Edit</a>
        |
        <a (click)="deleteMenu(data.gstibo_menu_id)">Delete</a>
      </p>
      <p> <a (click)="AddSubMenu(data.gstibo_menu_id)">Add Sub Menu</a> </p>
    </div>
  
  </div> -->